import React from "react";
import Navbar from "../landing Page/landing navbar/index";
import Footer from "../landing Page/Footer";
import { Box } from "@mui/material";

const LandingLayout = ({ children }) => {
   return (
      <main style={{ backgroundColor: "#F5F7FF" }} className="text-slate-800 min-h-screen">
         {/* Header / Navbar */}
         <Box
            sx={{
               zIndex: 100,
               position: "sticky",
               top: 0,
               width: "100%",
                borderBottom: "none !important",
      boxShadow: "none !important",
       border: "none !important",        // ← add this
    backgroundColor: "transparent",   // ← add this
            }}
         >
            <Navbar />
         </Box>

         {/* Page Content */}
         <div>{children}</div>

         {/* Footer */}
         <Footer />
      </main>
   );
};

export default LandingLayout;
